module.exports = __webpack_public_path__ + "img/MULTISPORT ROSEMERE.40567e9a.jpg";